import { render, staticRenderFns } from "./ShadowDomainDelete.vue?vue&type=template&id=e8464cc6&scoped=true"
import script from "./ShadowDomainDelete.vue?vue&type=script&lang=js"
export * from "./ShadowDomainDelete.vue?vue&type=script&lang=js"
import style0 from "./ShadowDomainDelete.vue?vue&type=style&index=0&id=e8464cc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8464cc6",
  null
  
)

export default component.exports